<template>
    <modal @close="$emit('close')" :show-title="true" :size="'medium'">
        <div slot="header">
            <h5 class="modal-title">{{$t('ordine.leggenda_informazioni')}}</h5>
        </div>
        <div slot="body">
            <div class="row legenda">
                <div class="col-sm-6" v-for="characteristic in this.characteristics">
                    <img :src="getCharacteristicIcon(characteristic)">
                    <b>
                        {{characteristic.nome.toUpperCase()}}
                    </b>
                </div>
            </div>
        </div>
    </modal>
</template>

<script>
    import {mapState} from 'vuex';
    import {getCharacteristicIcon} from '../../../api/core';

    import Modal from '../../partials/Modal';

    export default {
        name: "ModalLegend",
        components: {Modal},
        props: ['characteristics'],
        computed: {
            ...mapState('localization', {
                language: state => state.language
            })
        },
        methods: {
            getCharacteristicIcon: function (characteristic) {
                return getCharacteristicIcon(this.language, characteristic.icona);
            },
        }
    }
</script>
